import { memo, useState } from "react";
import { Carousel } from "primereact/carousel";
import { carouselPt } from "../../content/utils/carouselConfig";
import { Image } from "primereact/image";

const ProductGallery = memo(({ fotos = [], image, alt, className, onError }) => {
  const [active, setActive] = useState(() => {
    if (Array.isArray(fotos) && fotos.length) {
      const idx = fotos.findIndex((f) => f.portada);
      return idx >= 0 ? idx : 0;
    }
    return 0;
  });

  const hasMultiple = Array.isArray(fotos) && fotos.length > 1;
  const single = fotos?.[0]?.image || image;

  const template = (foto) => (
    <Image
      src={foto?.image}
      alt={alt}
      loading="lazy"
      onError={onError}
      preview
    />
  );

  if (!hasMultiple) {
    return (
      <Image
        src={single}
        alt={alt}
        onError={onError}
        preview
      />
    );
  }

  return (
    <Carousel
      value={fotos}
      page={active}
      onPageChange={(e) => setActive(e.page)}
      numVisible={1}
      numScroll={1}
      showIndicators
      showIndicatorsOnItem={false}
      itemTemplate={template}
      className={className}
      pt={carouselPt}
    />
  );
});

export default ProductGallery;